/**
 * Ukrainian UI strings. Every visible text comes from here, so a second language is a second
 * object of the same type (spec §9: UI in Ukrainian, English optional).
 */
export const uk = {
  appName: 'DeliCRM',
  nav: {
    catalogue: 'Каталог',
    orders: 'Замовлення',
    payments: 'Оплати',
    customers: 'Клієнти',
    pricing: 'Ціни',
    system: 'Стан системи',
    users: 'Користувачі',
    settings: 'Налаштування',
    audit: 'Журнал змін',
    loyalty: 'Q-бали',
    logout: 'Вийти',
  },
  common: {
    loading: 'Завантаження…',
    loadFailed: 'Не вдалося завантажити дані',
    retry: 'Спробувати ще раз',
    save: 'Зберегти',
    saved: 'Збережено',
    cancel: 'Скасувати',
    yes: 'Так',
    no: 'Ні',
    noAccess: 'Недостатньо прав для цієї сторінки',
    search: 'Пошук',
    all: 'Усі',
    reason: 'Причина зміни',
    remove: 'Видалити',
    add: 'Додати',
    edit: 'Змінити',
    previous: '← Попередні',
    next: 'Наступні →',
    shown: 'Показано',
    of: 'з',
    invalidAmount: 'Введіть суму в гривнях, напр. 1299,50',
  },
  roles: {
    admin: 'Адміністратор',
    senior_manager: 'Старший менеджер',
    manager: 'Менеджер',
    warehouse: 'Склад',
  },
  login: {
    title: 'Вхід у DeliCRM',
    email: 'Email',
    password: 'Пароль',
    submit: 'Увійти',
    submitting: 'Вхід…',
  },
  system: {
    title: 'Стан системи',
    api: 'API',
    database: 'База даних',
    migrations: 'Міграції',
    ok: 'Працює',
    down: 'Недоступно',
    applied: 'Застосовано',
    pending: 'Не застосовано',
    build: 'Збірка',
    apiVersion: 'Версія API',
  },
  users: {
    title: 'Користувачі',
    name: 'Імʼя',
    email: 'Email',
    role: 'Роль',
    status: 'Статус',
    active: 'Активний',
    inactive: 'Вимкнений',
    locked: 'Заблоковано до',
    add: 'Додати користувача',
    initialPassword: 'Пароль (мін. 12 символів)',
    create: 'Створити',
    deactivate: 'Вимкнути',
    activate: 'Увімкнути',
    newPassword: 'Новий пароль',
    setPassword: 'Змінити пароль',
    passwordSet: 'Пароль змінено, користувача вийшло з усіх сесій',
  },
  settings: {
    title: 'Налаштування',
    default: 'За замовчуванням',
    range: 'Допустимо',
    isSet: 'Задано',
    notSet: 'Не задано',
    newSecret: 'Новий секрет (мін. 16 символів)',
    clear: 'Очистити',
    lastChanged: 'Змінено',
    storeTitle: 'Магазин (DeliStore)',
    storeIntro:
      'Плагін DeliStore на сайті підписує свої запити спільним секретом, а DeliCRM надсилає на вебхук магазину зміни цін, залишків і статусів замовлень з магазину. Події для магазину ставляться в чергу, лише коли задано і адресу, і секрет.',
    n8nTitle: 'n8n',
    n8nIntro:
      'DeliCRM надсилає всі події у ваш n8n. Вкажіть адресу вебхука та секрет підпису вище.',
    webhook: 'Вебхук',
    secret: 'Секрет підпису',
    configured: 'Налаштовано',
    notConfigured: 'Не налаштовано',
    pendingEvents: 'Очікують відправки',
    failedEvents: 'Не доставлено',
    lastSent: 'Остання доставка',
    sendTest: 'Надіслати тестову подію',
    testDelivered: 'Тестову подію доставлено',
    testFailed: 'Не доставлено',
    discard: 'Відкинути чергу',
    discarded: 'Відкинуто подій',
  },
  catalogue: {
    title: 'Каталог',
    searchPlaceholder: 'Артикул або назва',
    category: 'Категорія',
    allCategories: 'Усі категорії',
    onlyActive: 'Лише активні',
    sku: 'Артикул',
    name: 'Назва',
    basePrice: 'Роздрібна ціна',
    costPrice: 'Собівартість',
    stock: 'Склад',
    onHand: 'На складі',
    reserved: 'У резерві',
    available: 'Доступно',
    inactive: 'Неактивний',
    empty: 'Товарів не знайдено',
    editTitle: 'Товар',
    newProduct: 'Новий товар',
    addProduct: '＋ Новий товар',
    close: 'Закрити',
    images: 'Зображення',
    heroImage: 'Головне зображення',
    extraImages: 'Додаткові зображення',
    noHero: 'Немає головного зображення',
    storeImage: 'Зображення з магазину',
    fromStoreHint:
      'Товар із магазину: назва, категорія і фото приходять з WooCommerce. Тут змінюються ціни, продаж і залишок.',
    replaceHero: 'Замінити',
    uploadHero: 'Завантажити',
    addImages: 'Додати зображення',
    moveLeft: 'Ліворуч',
    moveRight: 'Праворуч',
    imageHint:
      'Типово показуються фото з WooCommerce (після підключення синхронізації); тут можна додати власні зображення для команди — на сайт вони не потрапляють. JPEG, PNG або WebP до 5 МБ; до 20 додаткових.',
    uploading: 'Завантаження зображень…',
    imagesFailed:
      'Товар створено, але частину зображень не завантажено — додайте їх у картці товару',
    expand: 'Розгорнути',
    collapse: 'Згорнути',
    addSubcategory: 'Підкатегорія',
    cancel: 'Скасувати',
    openingStock: 'Початковий залишок',
    categoryHint:
      'Оберіть зі списку або введіть новий шлях («Обличчя / Маски») — його буде створено',
    createProduct: 'Створити товар',
    productCreated: 'Товар створено',
    noCategory: 'Без категорії',
    categoriesTitle: 'Категорії',
    parent: 'Батьківська категорія',
    topLevel: 'Верхній рівень',
    products: 'Товарів',
    rename: 'Назва',
    addCategory: 'Додати категорію',
    deleteHint: 'Видалити можна лише порожню категорію (без товарів і підкатегорій)',
    active: 'Активний',
    countTitle: 'Інвентаризація',
    countHint: 'Фактична кількість замінює залишок; резерви замовлень не змінюються.',
    saveCount: 'Зберегти залишок',
    importTitle: 'Імпорт з CSV',
    importHint:
      'Колонки: sku, name, base_price (обовʼязкові); category («Обличчя / Сироватки»), cost_price, is_active, on_hand. Ціни в гривнях. Порожня клітинка — залишити як є. Роздільник «,» або «;».',
    file: 'Файл CSV',
    check: 'Перевірити',
    apply: 'Імпортувати',
    created: 'Нових',
    updated: 'Змінених',
    unchanged: 'Без змін',
    newCategories: 'Нові категорії',
    errors: 'Помилки — нічого не записано',
    line: 'Рядок',
    applied: 'Імпорт виконано',
    preview: 'Перевірка (нічого не записано)',
  },
  customers: {
    title: 'Клієнти',
    searchPlaceholder: 'Імʼя, телефон, email, компанія або ЄДРПОУ',
    type: 'Тип',
    status: 'Статус',
    name: 'Імʼя',
    phone: 'Телефон',
    email: 'Email',
    company: 'Компанія',
    empty: 'Клієнтів не знайдено',
    add: 'Новий клієнт',
    create: 'Створити',
    types: { b2c: 'B2C', b2b: 'B2B' },
    statuses: {
      pending_approval: 'Очікує підтвердження',
      active: 'Активний',
      rejected: 'Відхилено',
      blocked: 'Заблоковано',
    },
    back: '← Усі клієнти',
    details: 'Дані клієнта',
    loyalty: 'Бере участь у програмі Q-балів',
    loyaltyB2bNote: 'B2B-клієнти не накопичують Q-бали',
    block: 'Заблокувати',
    unblock: 'Розблокувати',
    approve: 'Підтвердити',
    reject: 'Відхилити',
    companyTitle: 'Реквізити компанії',
    legalName: 'Назва',
    edrpou: 'ЄДРПОУ / РНОКПП',
    ipn: 'ІПН',
    vatPayer: 'Платник ПДВ',
    legalAddress: 'Юридична адреса',
    iban: 'IBAN',
    removeCompany: 'Видалити реквізити',
    contactsTitle: 'Контактні особи',
    contactName: 'Імʼя',
    contactRole: 'Посада',
    noContacts: 'Контактів немає',
    addressesTitle: 'Адреси доставки (Нова пошта)',
    npHint:
      'Пошук відділень Нової пошти зʼявиться разом із модулем доставки; поки що вкажіть ref міста й відділення.',
    city: 'Місто',
    cityRef: 'Ref міста',
    warehouse: 'Відділення',
    warehouseRef: 'Ref відділення',
    recipient: 'Отримувач',
    recipientPhone: 'Телефон отримувача',
    isDefault: 'Основна',
    makeDefault: 'Зробити основною',
    noAddresses: 'Адрес немає',
    ordersTitle: 'Історія замовлень',
    ordersNoAccess: 'Замовлення бачать менеджери та склад.',
    created: 'Створено',
    viewLogged: 'Перегляд картки записано в журнал змін (доступ до персональних даних).',
  },
  pricing: {
    title: 'Ціни',
    intro:
      'Партнерські й персональні знижки та акції. Ціни рахує лише сервер (той самий розрахунок, що й для сайту та замовлень); перед збереженням їх можна перевірити на пробному кошику.',
    discountsTitle: 'Знижки клієнтів',
    newDiscount: 'Нова знижка',
    discountTitle: 'Знижка клієнта',
    noDiscounts: 'Знижок немає',
    promotionsTitle: 'Акції',
    newPromotion: 'Нова акція',
    promotionTitle: 'Акція',
    noPromotions: 'Акцій немає',
    customer: 'Клієнт',
    findCustomer: 'Знайти клієнта',
    pickCustomer: 'Оберіть клієнта',
    otherCustomer: 'Інший клієнт',
    target: 'На що діє',
    targets: { all: 'Усі товари', category: 'Категорія', product: 'Товар' },
    findProduct: 'Артикул або назва товару',
    pickCategory: 'Оберіть категорію',
    discount: 'Знижка',
    mode: 'Вид знижки',
    modes: { percent_off: 'Відсоток від ціни', fixed_price: 'Фіксована ціна' },
    percent: 'Знижка, %',
    price: 'Ціна, ₴',
    invalidPercent: 'Відсоток — число від 0,01 до 100',
    validFrom: 'Діє з',
    validTo: 'Діє по (включно)',
    period: 'Період',
    always: 'безстроково',
    from: 'з',
    to: 'по',
    state: 'Стан',
    states: { active: 'Діє', scheduled: 'Заплановано', ended: 'Завершено' },
    reason: 'Причина',
    name: 'Назва',
    appliesTo: 'Для кого',
    stackable: 'Сумується з персональною знижкою (лише відсоткова)',
    stackableHint:
      'Без цієї позначки клієнт отримує кращу з двох цін: персональну або акційну (від ціни рівня).',
    stackableShort: 'сумується',
    deleteReason: 'Причина видалення',
    confirmDelete: 'Видалити остаточно',
    partner: 'Партнерська знижка',
    partnerNone: 'не встановлено',
    partnerHint: 'Знижка на весь асортимент від базової ціни: B2B-ціна = базова − %.',
    pendingNote:
      'Поки реєстрацію не схвалено, клієнт купує за роздрібними цінами; знижки почнуть діяти після схвалення.',
    blockedNote:
      'Клієнта заблоковано: ціни для нього не розраховуються (ні на сайті, ні в замовленнях), доки його не розблокують.',
    cardTitle: 'Знижки та ціни',
    readOnly: 'Змінювати знижки може старший менеджер або адміністратор.',
    preview: {
      title: 'Перевірка цін',
      hint: 'Пробний кошик: нічого не зберігається.',
      draftHint: 'Розрахунок враховує зміни з форми вище, ще до збереження.',
      guest: 'Гість (без клієнта)',
      guestType: 'Тип гостя',
      addProduct: 'Додати товар',
      qty: 'К-сть',
      calculate: 'Розрахувати',
      base: 'Базова',
      unit: 'Ціна',
      lineTotal: 'Сума',
      subtotal: 'Разом',
      empty: 'Додайте товари до пробного кошика.',
      fixDraft: 'Виправте форму, щоб розрахувати з новими значеннями.',
      tier: 'рівень',
      personal: 'персональна',
      promo: 'акція',
      override: 'ручна ціна',
      priceFor: 'Ціни для',
    },
  },
  orders: {
    title: 'Замовлення',
    number: '№',
    date: 'Дата',
    customer: 'Клієнт',
    status: 'Статус',
    paymentStatus: 'Оплата',
    paymentMethod: 'Спосіб оплати',
    channel: 'Канал',
    total: 'Сума',
    empty: 'Замовлень не знайдено',
    searchPlaceholder: 'Номер замовлення або клієнт',
    from: 'Від',
    to: 'До',
    newOrder: 'Нове замовлення',
    pickCustomer: 'Для кого замовлення?',
    create: 'Створити чернетку',
    back: '← Усі замовлення',
    views: {
      all: 'Усі',
      awaiting_payment: 'Очікують оплати',
      to_ship: 'До відправки',
      cod_unsettled: 'Накладений платіж не отримано',
    },
    statuses: {
      draft: 'Чернетка',
      awaiting_payment: 'Очікує оплати',
      confirmed: 'Підтверджено',
      shipped: 'Відправлено',
      delivered: 'Доставлено',
      completed: 'Завершено',
      cancelled: 'Скасовано',
      returned: 'Повернено',
    },
    paymentStatuses: {
      unpaid: 'Не оплачено',
      partially_paid: 'Частково оплачено',
      paid: 'Оплачено',
      overpaid: 'Переплата',
      refunded: 'Кошти повернено',
    },
    methods: { card: 'Картка', bank_transfer: 'Рахунок (безготівково)', cod: 'Накладений платіж' },
    channels: { woo: 'Сайт', manager: 'Менеджер', legacy: 'KeyCRM' },
    wooOrder: 'замовлення на сайті',
    returnUntil: 'повернення до',
    attentionTitle: 'Перевірте',
    attentionBadge: 'Перевірити',
    attentionHint:
      'Замовлення вже оплачене на сайті: DeliCRM записав його як є і показує, чим воно відрізняється.',
    returnWindow: (days: number) => `вікно повернення ${days} дн.`,
    delivery: { nova_post: 'Нова пошта', pickup: 'Самовивіз' },
    linesTitle: 'Товари',
    noLines: 'Додайте товари: ціни розраховуються одразу.',
    addProduct: 'Додати товар',
    qty: 'К-сть',
    base: 'Базова',
    unit: 'Ціна',
    lineTotal: 'Сума',
    subtotal: 'Сума товарів',
    discountTotal: 'Знижки на товари',
    points: 'Оплачено балами',
    grandTotal: 'До сплати',
    override: 'Ручна ціна',
    overrideMode: 'Як змінити',
    overrideModes: { price: 'Нова ціна, ₴', percent: 'Знижка, %' },
    overrideValue: 'Значення',
    overrideClear: 'Прибрати',
    overrideApply: 'Застосувати',
    saveLines: 'Зберегти товари',
    editReason: 'Причина зміни (обовʼязкова для оформленого замовлення)',
    unsaved: 'Є незбережені зміни',
    deliveryTitle: 'Доставка',
    deliveryMethod: 'Спосіб доставки',
    recipientName: 'Отримувач',
    recipientPhone: 'Телефон отримувача',
    city: 'Місто',
    warehouse: 'Відділення',
    comment: 'Коментар',
    saveDetails: 'Зберегти доставку',
    npHint:
      'Пошук відділень Нової пошти зʼявиться з модулем доставки; поки вкажіть місто й відділення текстом.',
    placeTitle: 'Оформлення',
    deferred: 'Відстрочка оплати (B2B, за рахунком)',
    place: 'Оформити замовлення',
    placeHint:
      'Ціни фіксуються, товар резервується, для оплати за рахунком формується рахунок — усе разом або нічого.',
    actionsTitle: 'Дії',
    cancel: 'Скасувати замовлення',
    ship: 'Відправлено',
    ttn: 'Номер ТТН (необовʼязково)',
    deliver: 'Доставлено',
    returnOrder: 'Оформити повернення',
    returnHint: 'Повне повернення: товар повертається на склад, усі оплачені кошти — клієнту.',
    reason: 'Причина',
    invoicesTitle: 'Рахунки',
    invoiceKinds: { initial: 'Рахунок', top_up: 'Доплата', credit_note: 'Кредит-нота' },
    invoiceStatuses: { open: 'Очікує оплати', paid: 'Сплачено', cancelled: 'Скасовано' },
    creditApplied: 'Враховано',
    outstanding: 'Залишок',
    due: 'Сплатити до',
    pdf: 'PDF',
    paymentsTitle: 'Оплати',
    noPayments: 'Оплат немає',
    returnTitle: 'Повернення',
    historyTitle: 'Історія',
    system: 'Система',
    history: {
      create: 'Створено чернетку',
      place: 'Оформлено',
      lines: 'Змінено товари',
      'line.override': 'Ручна ціна',
      details: 'Змінено доставку',
      cancel: 'Скасовано',
      ship: 'Відправлено',
      deliver: 'Доставлено',
      return: 'Повернення',
    } as Record<string, string>,
    customerOrders: 'Замовлення клієнта',
  },
  payments: {
    title: 'Оплати',
    direction: 'Напрям',
    directions: { in: 'Надходження', refund: 'Повернення' },
    order: 'Замовлення',
    amount: 'Сума, ₴',
    method: 'Спосіб',
    provider: 'Джерело',
    providers: { manual: 'Вручну' } as Record<string, string>,
    reference: 'Документ / номер платежу',
    receivedAt: 'Коли',
    reason: 'Причина / коментар',
    empty: 'Оплат немає',
    record: 'Внести оплату',
    refund: 'Оформити повернення коштів',
    recordTitle: 'Оплата вручну',
    recordHint:
      'Для грошей, що надійшли поза платіжними модулями: банківська виписка, готівка, накладений платіж.',
    orderNumber: 'Номер замовлення',
    openOrder: 'Відкрити →',
    findOrder: 'Знайти',
    orderNotFound: 'Замовлення з таким номером не знайдено',
    isRefund: 'Це повернення коштів клієнту',
    save: 'Записати',
  },
  loyalty: {
    title: 'Q-бали',
    intro:
      'Кешбек для роздрібних клієнтів: бали нараховуються на оплачене, стають доступними після вікна повернення і списуються як знижка на замовлення. Зміни діють лише для нових замовлень; наявні бали й дати їх згорання не змінюються.',
    settingsTitle: 'Налаштування',
    enabled: 'Програма увімкнена',
    accrualPercent: 'Нарахування, % від оплаченого',
    pointValue: 'Вартість 1 бала, ₴',
    maxRedeemPercent: 'Максимум балами, % замовлення',
    noCap: 'порожньо — без обмеження',
    expiryMonths: 'Термін дії, місяців',
    noExpiry: 'порожньо — не згорають',
    reason: 'Причина зміни',
    check: 'Перевірити',
    apply: 'Зберегти нову версію',
    unchanged: 'Нічого не змінено.',
    applied: (version: number) => `Збережено як версію ${version}.`,
    conversion: (customers: number, before: number, after: number) =>
      `Зміна вартості бала перерахує баланси ${customers} клієнтів: ${before} → ${after} балів (у гривнях — без змін).`,
    noConversion: 'Баланси клієнтів не зміняться.',
    historyTitle: 'Історія версій',
    version: 'Версія',
    from: 'Діє з',
    on: 'увімк.',
    off: 'вимк.',
    never: 'не згорають',
    noLimit: 'без обмеження',
    months: (n: number) => `${n} міс.`,
    by: 'Хто',
    reportsTitle: 'Звіти',
    outstanding: 'Невикористані бали',
    asOf: 'Станом на',
    now: 'зараз',
    active: 'Доступні',
    pending: 'Очікують',
    customersWith: 'Клієнтів',
    movement: 'Рух балів за місяць',
    month: 'Місяць',
    kinds: {
      accrue: 'Нараховано',
      redeem: 'Списано',
      reverse: 'Повернено / забрано',
      expire: 'Згоріло',
      adjust: 'Коригування',
      convert: 'Перерахунок',
    } as Record<string, string>,
    statuses: { pending: 'очікує', active: 'доступно', cancelled: 'скасовано' } as Record<
      string,
      string
    >,
    entries: 'Записів',
    noMovement: 'Руху балів немає',
    // Customer card
    cardTitle: 'Q-бали',
    spendable: 'Доступно',
    pendingPoints: 'Очікують',
    debt: 'Борг',
    pointsWorth: (points: number, money: string) => `${points} балів = ${money}`,
    nearest: (points: number, date: string) => `${points} балів згорять ${date}`,
    lotsTitle: 'Бали за датою згорання',
    lotSource: 'Звідки',
    lotFromOrder: 'замовлення',
    lotAdjust: 'коригування',
    earned: 'Отримано',
    left: 'Лишилось',
    expires: 'Згорають',
    historyEntries: 'Історія',
    when: 'Коли',
    what: 'Що',
    points: 'Бали',
    order: 'Замовлення',
    noEntries: 'Балів ще немає',
    adjustTitle: 'Коригування балів',
    adjustPoints: 'Бали (мінус — списати)',
    adjustReason: 'Причина',
    adjust: 'Провести',
    // Order card
    orderTitle: 'Q-бали',
    orderAvailable: (max: number) => `Можна списати до ${max} балів`,
    orderSpend: 'Списати балів',
    orderSave: 'Застосувати',
    orderToEarn: (n: number) => `Нарахується після оплати: ${n} балів`,
    orderEarned: (n: number, status: string) => `Нараховано ${n} балів (${status})`,
    orderNone: 'Клієнт не бере участі в програмі або балів немає.',
  },
  audit: {
    title: 'Журнал змін',
    entity: 'Обʼєкт',
    entityId: 'ID обʼєкта',
    filter: 'Показати',
    when: 'Коли',
    who: 'Хто',
    what: 'Що',
    before: 'Було',
    after: 'Стало',
    reason: 'Причина',
    system: 'Система',
    empty: 'Записів немає',
    more: 'Показати ще',
  },
} as const;

export type Strings = typeof uk;

export const t: Strings = uk;
